export const pageSizes = [
  { label: 'Small', size: 3 },
  { label: 'Medium', size: 4 },
  { label: 'Large', size: 6 },
  { label: 'Xtra Large', size: 12 },
]
